import React, { useCallback, useEffect, useState } from "react";
import {
  TextField,
  MenuItem,
  Box,
  Typography,
  Button,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  Checkbox,
  ListItemText,
  Autocomplete,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup"; // For validation
import { toast } from "react-toastify";
import { getAllAgentsService } from "../../services/agentService";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../utils/apiUtils";
import debounce from "lodash/debounce";
import { createGroupLoanService } from "../../services/loanService";
import { createGroupPigmyService } from "../../services/pigmyService";

// Validation Schema
const LoanSchema = Yup.object().shape({
  groupName: Yup.string(),
  groupLeaderPhoneNumber: Yup.string(),
  agent: Yup.string().required("Agent is required"),
  pigmyPlan: Yup.string().required("Pigmy Plan is required"),
  // loanAmount: Yup.number().required("Loan Amount is required"),
  frequency: Yup.string().required("Frequency is required"),
  startDate: Yup.date().required("Start Date is required"),
  endDate: Yup.date().required("End Date is required"),
  // processingFee: Yup.number().required("Processing Fees is required"),
  // interestAmount: Yup.number().required("Interest Amount is required"),
  // loanTenure: Yup.string().required("Loan Tenure is required"),
  // amountToBePaidBy: Yup.string().required("Amount to be paid by is required"),
  // disbursedAmount: Yup.number().required("Disbursed Amount is required"),
  collectionAmount: Yup.number().required("Collection Amount is required"),
  // interest: Yup.number().required("Interest is required"),
  customers: Yup.array()
    .min(1, "Please select at least one customer")
    .required("Customers are required"),
});

const CreatePigmy = () => {
  const [selectedCustomers, setSelectedCustomers] = useState();
  const [agents, setAgents] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const navigate = useNavigate(); // Fetch customers data
  const token = sessionStorage.getItem("accessToken");

  const fetchAgents = async () => {
    try {
      const agents = await getAllAgentsService();
      setAgents(agents?.agentsWithPhoneContacts);
    } catch (err) {
      toast.error(err.message);
    }
  };
  // const fetchCustomers = async () => {
  //   // Mock customer fetching or real API call
  //   const mockCustomers = [
  //     { _id: "1", name: "Customer 1" },
  //     { _id: "2", name: "Customer 2" },
  //     { _id: "3", name: "Customer 3" },
  //   ];
  // };
  const fetchOptions = async (query) => {
    if (!query) {
      setOptions([]); // Clear options if query is empty
      return;
    }
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}/customer/search-customer`, {
        params: { query },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setOptions(response.data || []); // Set options or empty array
    } catch (error) {
      console.error("Error fetching options:", error);
      setOptions([]); // Clear options on error
    }
    setLoading(false);
  };

  const debouncedFetchOptions = useCallback(
    debounce((query) => {
      fetchOptions(query);
    }, 1000),
    []
  );
  // const calculateCollectionAmount = (values, tenure) => {
  //   if (values.loanAmount) {
  //     const collectionAmount = values.loanAmount / tenure;
  //     return { amount: collectionAmount };
  //   }
  // };

  // const calculateInterestAndCollection = (values) => {
  //   if (values.loanAmount) {
  //     const totalAmount = (values.loanAmount * values.interest) / 100;
  //     const collectionAmount =
  //       (totalAmount + values.loanAmount) / values.loanTenure;
  //     return { amount: collectionAmount };
  //   }
  // };

  // const calculateInterest = (values) => {
  //   const collectionAmount = (values.loanAmount * values.interest) / 100;
  //   return { amount: collectionAmount };
  // };

  const calculateEndDate = (values, frequency) => {
    let startDate = new Date();
    let endDate = new Date(startDate); // Copy startDate

    if (frequency === "Daily") {
      endDate.setDate(startDate.getDate() + values?.loanTenure);
    } else if (frequency === "Weekly") {
      endDate.setDate(startDate.getDate() + values?.loanTenure * 7);
    } else if (frequency === "Monthly") {
      endDate.setMonth(startDate.getMonth() + values?.loanTenure);
      if (startDate.getDate() !== endDate.getDate()) {
        endDate.setDate(startDate.getDate());
      }
    }

    return {
      startDate: startDate.toISOString().split("T")[0],
      endDate: endDate.toISOString().split("T")[0],
    };
  };

  const handleSubmit = async (values) => {
    try {
      // Include user ID with the form values
      // const payload = { ...values, user: "userId" }; // Adjust as per your context
      await createGroupPigmyService(values);
      toast.success("Group Pigmy created successfully!");
      // navigate("/group-loan");
    } catch (error) {
      toast.error("Failed to create Loan");
    }
  };

  const calculateDates = (plan) => {
    const startDate = new Date();
    let endDate = new Date();
    if (plan === "12") {
      endDate.setFullYear(startDate.getFullYear() + 1);
    } else if (plan === "6") {
      endDate.setMonth(startDate.getMonth() + 6);
    } else if (plan === "24") {
      endDate.setFullYear(startDate.getFullYear() + 2);
    } else if (plan === "36") {
      endDate.setFullYear(startDate.getFullYear() + 3);
    }
    return {
      startDate: startDate.toISOString().split("T")[0],
      endDate: endDate.toISOString().split("T")[0],
    };
  };

  useEffect(() => {
    fetchAgents();
    console.log();
  }, []);

  return (
    <Box sx={{ p: 4, backgroundColor: "#fff", borderRadius: "8px" }}>
      <Typography variant="h5" mb={2}>
        Create Group Pigmy
      </Typography>
      <Formik
        initialValues={{
          groupName: "",
          groupLeaderPhoneNumber: "",
          agent: "",
          pigmyPlan: "",
          // loanAmount: "",
          frequency: "",
          startDate: null,
          endDate: null,
          // processingFee: 0,
          // interestAmount: 0,
          // loanTenure: "",
          // amountToBePaidBy: "",
          // disbursedAmount: "",
          collectionAmount: "",
          // interest: 5,
          // collectionDay: "",
          customers: [], // Initialize customers as an empty array
        }}
        validationSchema={LoanSchema}
        onSubmit={handleSubmit}
      >
        {({ values, handleChange, setFieldValue, errors, touched }) => (
          <Form>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                gap: 2,
              }}
            >
              <Box>
                <Typography>Group Name *</Typography>
                <Field
                  as={TextField}
                  size="small"
                  name="groupName"
                  fullWidth
                  error={touched.groupName && Boolean(errors.groupName)}
                  helperText={touched.groupName && errors.groupName}
                  required
                />
              </Box>
              <Box>
                <Typography>Group Leader Phone Number *</Typography>
                <Field
                  as={TextField}
                  size="small"
                  name="groupLeaderPhoneNumber"
                  fullWidth
                  error={
                    touched.groupLeaderPhoneNumber &&
                    Boolean(errors.groupLeaderPhoneNumber)
                  }
                  helperText={
                    touched.groupLeaderPhoneNumber &&
                    errors.groupLeaderPhoneNumber
                  }
                  required
                />
              </Box>
              {/* Agent Field */}
              <Box>
                <Typography>Agent *</Typography>
                <Field
                  as={TextField}
                  size="small"
                  name="agent"
                  select
                  fullWidth
                  error={touched.agent && Boolean(errors.agent)}
                  helperText={touched.agent && errors.agent}
                  required
                >
                  {agents.map((agent) => (
                    <MenuItem key={agent._id} value={agent._id}>
                      {agent.userName}
                    </MenuItem>
                  ))}
                </Field>
              </Box>
              <Box>
                <Typography>Pigmy Plan *</Typography>
                <Field
                  as={TextField}
                  name="pigmyPlan"
                  size="small"
                  select
                  fullWidth
                  error={touched.pigmyPlan && Boolean(errors.pigmyPlan)}
                  helperText={touched.pigmyPlan && errors.pigmyPlan}
                  required
                  onChange={(e) => {
                    handleChange(e);
                    const { startDate, endDate } = calculateDates(
                      e.target.value
                    );
                    setFieldValue("startDate", startDate);
                    setFieldValue("endDate", endDate);
                  }}
                >
                  <MenuItem value="6">6 months</MenuItem>
                  <MenuItem value="12">12 months</MenuItem>
                  <MenuItem value="24">24 months</MenuItem>
                  <MenuItem value="36">36 months</MenuItem>
                </Field>
              </Box>

              {/* Loan Amount Field */}
              {/* <Box>
                <Typography>Loan Amount *</Typography>
                <Field
                  as={TextField}
                  size="small"
                  name="loanAmount"
                  type="number"
                  fullWidth
                  error={touched.loanAmount && Boolean(errors.loanAmount)}
                  helperText={touched.loanAmount && errors.loanAmount}
                  required
                />
              </Box> */}

              {/* Loan Tenure Field */}
              {/* <Box>
                <Typography>Loan Tenure *</Typography>
                <Field
                  as={TextField}
                  size="small"
                  name="loanTenure"
                  type="number"
                  fullWidth
                  error={touched.loanTenure && Boolean(errors.loanTenure)}
                  helperText={touched.loanTenure && errors.loanTenure}
                  required
                  onChange={(e) => {
                    handleChange(e);
                    const { amount } = calculateCollectionAmount(
                      values,
                      e.target.value
                    );
                    setFieldValue("collectionAmount", amount);
                  }}
                />
              </Box> */}

              {/* Frequency Field */}
              <Box>
                <Typography>Frequency *</Typography>
                <Field
                  as={TextField}
                  name="frequency"
                  size="small"
                  select
                  fullWidth
                  error={touched.frequency && Boolean(errors.frequency)}
                  helperText={touched.frequency && errors.frequency}
                  required
                >
                  <MenuItem value="Daily">Daily</MenuItem>
                  <MenuItem value="Weekly">Weekly</MenuItem>
                  <MenuItem value="Monthly">Monthly</MenuItem>
                </Field>
              </Box>

              {/* Interest Field */}
              {/* <Box>
                <Typography>Interest *</Typography>
                <Field
                  as={TextField}
                  size="small"
                  name="interest"
                  type="number"
                  fullWidth
                  error={touched.interest && Boolean(errors.interest)}
                  helperText={touched.interest && errors.interest}
                  required
                />
              </Box>

              {/* Amount to be Paid By Field */}
              {/* <Box>
                <Typography>Amount to be Paid By *</Typography>
                <Field
                  as={TextField}
                  size="small"
                  name="amountToBePaidBy"
                  select
                  fullWidth
                  error={
                    touched.amountToBePaidBy && Boolean(errors.amountToBePaidBy)
                  }
                  helperText={
                    touched.amountToBePaidBy && errors.amountToBePaidBy
                  }
                  required
                  onChange={(e) => {
                    handleChange(e);
                    if (e.target.value === "interest") {
                      const { amount } = calculateInterest(values);
                      setFieldValue("collectionAmount", amount);
                    } else if (e.target.value === "interest+emi") {
                      const { amount } = calculateInterestAndCollection(values);
                      setFieldValue("collectionAmount", amount);
                    } else {
                      const { amount } = calculateCollectionAmount(
                        values,
                        values.loanTenure
                      );
                      setFieldValue("collectionAmount", amount);
                    }
                  }}
                >
                  <MenuItem value="interest">Interest</MenuItem>
                  <MenuItem value="interest+emi">Interest + EMI</MenuItem>
                  <MenuItem value="emi">EMI</MenuItem>
                </Field>
              </Box> */}

              {/* Start Date Field */}
              <Box>
                <Typography>Start Date *</Typography>
                <Field
                  as={TextField}
                  name="startDate"
                  type="date"
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  error={touched.startDate && Boolean(errors.startDate)}
                  helperText={touched.startDate && errors.startDate}
                  required
                />
              </Box>

              {/* End Date Field */}
              <Box>
                <Typography>End Date *</Typography>
                <Field
                  as={TextField}
                  name="endDate"
                  type="date"
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  error={touched.endDate && Boolean(errors.endDate)}
                  helperText={touched.endDate && errors.endDate}
                  required
                />
              </Box>

              {/* Processing Fees Field */}
              {/* <Box>
                <Typography>Processing Fees *</Typography>
                <Field
                  as={TextField}
                  name="processingFee"
                  type="number"
                  size="small"
                  fullWidth
                  error={touched.processingFee && Boolean(errors.processingFee)}
                  helperText={touched.processingFee && errors.processingFee}
                  required
                />
              </Box> */}

              {/* Interest Amount Field */}
              {/* <Box>
                <Typography>Interest Amount *</Typography>
                <Field
                  as={TextField}
                  name="interestAmount"
                  type="number"
                  size="small"
                  fullWidth
                  error={
                    touched.interestAmount && Boolean(errors.interestAmount)
                  }
                  helperText={touched.interestAmount && errors.interestAmount}
                  required
                />
              </Box> */}

              {/* Disbursed Amount Field */}
              {/* <Box>
                <Typography>Disbursed Amount *</Typography>
                <Field
                  as={TextField}
                  name="disbursedAmount"
                  type="number"
                  size="small"
                  fullWidth
                  error={
                    touched.disbursedAmount && Boolean(errors.disbursedAmount)
                  }
                  helperText={touched.disbursedAmount && errors.disbursedAmount}
                  required
                />
              </Box> */}

              {/* Collection Amount Field */}
              <Box>
                <Typography>Collection Amount *</Typography>
                <Field
                  as={TextField}
                  name="collectionAmount"
                  type="number"
                  size="small"
                  fullWidth
                  error={
                    touched.collectionAmount && Boolean(errors.collectionAmount)
                  }
                  helperText={
                    touched.collectionAmount && errors.collectionAmount
                  }
                  required
                />
              </Box>
              {/* {values.frequency === "weekly" ? (
                <Box>
                  <Typography>Collection Day *</Typography>
                  <Field
                    as={TextField}
                    size="small"
                    name="collectionDay"
                    select
                    fullWidth
                    error={
                      touched.collectionDay && Boolean(errors.collectionDay)
                    }
                    helperText={touched.collectionDay && errors.collectionDay}
                    required
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  >
                    <MenuItem value="sunday">Sunday</MenuItem>
                    <MenuItem value="monday">Monday</MenuItem>
                    <MenuItem value="tuesday">Tuesday</MenuItem>
                    <MenuItem value="wednesday">Wednesday</MenuItem>
                    <MenuItem value="thursday">Thursday</MenuItem>
                    <MenuItem value="friday">Friday</MenuItem>
                    <MenuItem value="saturday">Saturday</MenuItem>
                  </Field>
                </Box>
              ) : null} */}
            </Box>
            <Box mt={2}>
              <Typography variant="h6">Add Members</Typography>
            </Box>
            {/* Multiple Select Customer Field */}
            {/* Autocomplete Multiple Select Customer Field */}
            <Box
              gridColumn="span 4"
              sx={{
                display: "flex",
                justifyContent: "space-between", // Adjusts space between FormControl and Button
                alignItems: "center",
                mt: 2,
              }}
            >
              <FormControl sx={{ width: "75%" }} size="small">
                <Autocomplete
                  multiple
                  id="customers"
                  options={options}
                  getOptionLabel={(option) =>
                    `${option.userName} (${option?.primaryPhone?.contactValue})` ||
                    ""
                  }
                  loading={loading}
                  loadingText="Loading customers..."
                  // Use values.customers to create a stable value list, independent of options
                  value={values.customers.map(
                    (id) =>
                      options.find((option) => option._id === id) ||
                      selectedCustomers.find((option) => option._id === id) || {
                        _id: id,
                        userName: "",
                        primaryPhone: { contactValue: "" },
                      }
                  )}
                  onInputChange={(event, newInputValue) => {
                    if (event && event.type === "change") {
                      debouncedFetchOptions(newInputValue);
                    }
                  }}
                  onChange={(event, selectedCustomers) => {
                    const selectedIds = selectedCustomers.map(
                      (customer) => customer?._id
                    );
                    setFieldValue("customers", selectedIds);
                    // Update the list of fully selected customer objects for stability
                    setSelectedCustomers(selectedCustomers);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Customers"
                      size="small"
                      error={touched.customers && Boolean(errors.customers)}
                      helperText={touched.customers && errors.customers}
                    />
                  )}
                />
              </FormControl>

              <Button
                type="submit"
                variant="contained"
                color="primary"
                sx={{ ml: 2 }}
                onClick={() => {
                  navigate("/customer/create-customer");
                }}
              >
                Create Customer
              </Button>
            </Box>

            <Box mt={4}>
              <Button type="submit" variant="contained" color="primary">
                Submit
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default CreatePigmy;
